module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAICAYAAACYhf2vAAAABHNCSVQICAgIfAhkiAAAAGtJREFUOE/Nk0ENgEAMBKcKQAoOCA6wwQskgAxUYKHnCAxcSS/hyfMo++yjM0m7gme3EWNG6IC2zGrGUIyNSVQKHI6avNfdmcEFFOhDBCC5gAXBHXtGC1y/OEHwEz41hAVKDZsPfiKRWb2GN9QbI3SsVKULAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bar_chart_blue_label.png
// module id = KAGi
// module chunks = 3